import { useQuery } from '@tanstack/react-query';

import { profilesApi } from '@/api';

export const useGetChat = (id: string | number) => {
    return useQuery({
        queryKey: ['chat'],
        queryFn: () => profilesApi.getChat(id),
        gcTime: 0,
        staleTime: 0,
    });
};
